import { Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-checkbox-multiselect',
  templateUrl: './checkbox-multiselect.component.html',
  styleUrls: ['./checkbox-multiselect.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CheckboxMultiselectComponent),
    multi: true,
  }]
})
export class CheckboxMultiselectComponent implements ControlValueAccessor {
  @Input() multiselectDisplay = {open: false};
  @Input() options = [];

  value = [];

  onChange = (form: any): void => { };
  onTouched = (): void => { };

  writeValue(obj: any): void {
    this.onChange(this.options)
    this.value = this.options
  }

  registerOnChange(fn: (form: any) => void) {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    throw new Error('Method not implemented.');
  }

  getNames(){
    return this.value ? this.value.filter(option => option.checked).map(option => option.name).join(', ') : ''; 
  }

  getValues() {
    return this.value ? this.value.map(option => option.checked ? option.name : null) : [];
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/checkbox-multiselect/checkbox-multiselect.component.ts